<template>
	<div class="header-wrapper d-none">
		<router-link class="text-decoration-none btn btn-outline-primary" to="/">
			⬅️ MC
		</router-link>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	name: 'Header',
	components: {},
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		...mapState(['token', 'authUser', 'account']),
		...mapGetters(['isAuth']),
	},
	methods: {},
}
</script>
